import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CenteredOverlay } from '@calendly/ui/components/centered-overlay';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { zIndexModal } from '@calendly/ui/z-index';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { AlmostThereConfetti } from './almost_there_confetti';
import AlmostThereSparklesIcon from './icons/almost_there_sparkles.svg';
const panelCss = "p9iemh";
const topRowCss = "t1uajucb";
const bodyBlockCss = "bftbubx";
const sparklesCss = "s1jxfl3q";
const Sparkles = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(sparklesCss, props.className)} />;
});
export const AlmostThereOverlay = ({
  onClose
}) => {
  const {
    data: {
      email: userEmail
    } = {}
  } = useGetUserQuery();
  const overlayAriaLabel = [I18n.t('publisher.home.ai_assistant_banner.almost_there.title'), I18n.t('publisher.home.ai_assistant_banner.almost_there.check_your_inbox')].join(' ');
  return <>
      <CenteredOverlay isOpen onClose={onClose} title={false} hasPadding={false} zIndex={zIndexModal} ariaLabel={overlayAriaLabel} data-testid="ai-assistant-almost-there-overlay">
        <div className={panelCss}>
          <div className={topRowCss}>
            <Sparkles src={AlmostThereSparklesIcon} alt="" />
            <BareButton type="button" decoration="ghost" onClick={onClose} aria-label={I18n.t('publisher.action.close')} data-testid="ai-assistant-almost-there-close">
              <CloseMiniIcon />
            </BareButton>
          </div>
          <TitleText size="large">
            {I18n.t('publisher.home.ai_assistant_banner.almost_there.title')}
            <br />
            {I18n.t('publisher.home.ai_assistant_banner.almost_there.check_your_inbox')}
          </TitleText>
          <div className={bodyBlockCss}>
            <BodyText size="large" as="div">
              {I18n.t('publisher.home.ai_assistant_banner.almost_there.description_part_1')}
              <BodyText size="large" as="span" weight="bold" inline>
                {userEmail ?? ''}
              </BodyText>
              {I18n.t('publisher.home.ai_assistant_banner.almost_there.description_part_2')}
            </BodyText>
          </div>
        </div>
      </CenteredOverlay>
      <AlmostThereConfetti />
    </>;
};

require("./almost_there.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./almost_there.js");